import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [{
        name: "Login",
        path: "/login",
        component: () =>
            import ("@/views/Login.vue"),
			// import ("@/views/DataV/Login.vue"),
        meta: {
            keepAlive: false, // 需要被缓存
            title: "登录",
        },
    },
    {
        name: "Home",
        path: "/",
        component: () =>
            import ("@/views/Home.vue"),
        meta: {
            keepAlive: false, // 需要被缓存
            title: "首页",
        },
    },
    {
        name: "Station",
        path: "/station",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../views/Station/Station.vue"),
        children: [{
                name: "StationManagement",
                path: "management",
                component: () =>
                    import ("@/views/Station/Management.vue"),
                meta: {
                    keepAlive: true, // 需要被缓存
                    title: "站点管理",
                },
            },
            {
                name: "StationOperating",
                path: "operating",
                component: () =>
                    import ("@/views/Station/Operating.vue"),
                meta: {
                    keepAlive: false, // 需要被缓存
                    title: "站点运营",
                },
            },
        ],
    },
    {
        name: "Devices",
        path: "/devices",
        component: () =>
            import ("../views/Devices/Devices.vue"),
        children: [{
                name: "ChargingPile",
                path: "pile",
                component: () =>
                    import ("@/views/Devices/ChargingPile.vue"),
                meta: {
                    keepAlive: false, // 需要被缓存
                    title: "充电桩",
                },
            },
            {
                name: "ChargingGun",
                path: "gun",
                component: () =>
                    import ("@/views/Devices/ChargingGun.vue"),
                meta: {
                    keepAlive: true, // 需要被缓存
                    title: "充电枪",
                },
            },
            {
                name: "GunDetails",
                path: "details",
                component: () =>
                    import ("@/views/Devices/Details.vue"),
                meta: {
                    keepAlive: false, // 需要被缓存
                    title: "充电枪详情",
                },
            },
        ],
    },
    {
        name: "Order",
        path: "/order",
        component: () =>
            import ("@/views/Order/Order.vue"),
        children: [{
                name: "OrderList",
                path: "list",
                component: () =>
                    import ("@/views/Order/List.vue"),
                meta: {
                    keepAlive: true, // 需要被缓存
                    title: "订单列表",
                },
            },
            {
                name: "OrderDetails",
                path: "details",
                component: () =>
                    import ("@/views/Order/Details.vue"),
                meta: {
                    keepAlive: false, // 需要被缓存
                    title: "订单详情",
                },
            },
            {
                name: "OrderOperating",
                path: "operating",
                component: () =>
                    import ("@/views/Order/Operating.vue"),
                meta: {
                    keepAlive: false, // 需要被缓存
                    title: "订单运营",
                },
            },
        ],
    },
    {
        name: "Coupons",
        path: "/coupons",
        component: () =>
            import ("@/views/Coupons/Coupons.vue"),
        children: [{
                name: "Template",
                path: "template",
                component: () =>
                    import ("@/views/Coupons/Template.vue"),
                meta: {
                    keepAlive: true, // 需要被缓存
                    title: "模板",
                },
            },
            {
                name: "UserCoupons",
                path: "userCoupons",
                component: () =>
                    import ("@/views/Coupons/UserCoupons.vue"),
                meta: {
                    keepAlive: true, // 需要被缓存
                    title: "持有优惠券",
                },
            },
            {
                name: "Activity",
                path: "activity",
                component: () =>
                    import ("@/views/Coupons/Activity.vue"),
                meta: {
                    keepAlive: true, // 需要被缓存
                    title: "活动",
                },
            },
        ],
    },
    {
        name: "User",
        path: "/user",
        component: () =>
            import ("@/views/User.vue"),
        meta: {
            keepAlive: true, // 需要被缓存
            title: "用户",
        },
    },
    {
        name: "Contact",
        path: "/contact",
        component: () =>
            import ("@/views/Contact.vue"),
        meta: {
            keepAlive: true, // 需要被缓存
            title: "互联互通",
        },
    },
    {
        name: "Ic",
        path: "/ic",
        component: () =>
            import ("@/views/Ic.vue"),
        meta: {
            keepAlive: true, // 需要被缓存
            title: "IC卡",
        },
    },
	{
	    name: "SystemParams",
	    path: "/systemParams",
	    component: () =>
	        import ("@/views/SystemParams.vue"),
	    meta: {
	        keepAlive: true, // 需要被缓存
	        title: "系统参数",
	    },
	},
    {
        name: "Set",
        path: "/set",
        component: () =>
            import ("@/views/Set.vue"),
        meta: {
            keepAlive: true, // 需要被缓存
            title: "设置",
        },
    },
    {
        name: "DataV",
        path: "/dataV",
        component: () =>
            import ("@/views/dataV.vue"),
        meta: {
            keepAlive: false, // 需要被缓存
            title: "大数据展示屏",
        },
    },
	{
	    name: "XJDataV",
	    path: "/XJDataV",
	    component: () =>
	        import ("@/views/XJDataV.vue"),
	    meta: {
	        keepAlive: false, // 需要被缓存
	        title: "大数据展示屏",
	    },
	},
	{
	    name: "AppDataV",
	    path: "/AppDataV",
	    component: () =>
	        import ("@/views/DataV/AppDataV.vue"),
	    meta: {
	        keepAlive: false, // 需要被缓存
	        title: "大数据展示屏",
	    },
	},
    {
        path: "/",
        redirect: "/",
    },
];

const router = new VueRouter({
    mode: "hash",
    routes,
});

export default router;